import React from "react"
import {RefTable, DefaultProps, Visibility, Validator} from "../RefTable"

export const Country = (props)=><RefTable {...props}/>;

Country.defaultProps = {
    ...DefaultProps,
    filterSchema: "country_filter",
    title: "Country Information",
    tableSchema: "country",
    tableName: "country",
    edit: true,
    theadHeight: 84,
    formVisibility:{
        is_article_194_applied: new Visibility("is_article_194_applied", (column, data)=>data.is_eu, ["is_eu"])
    },
    validator: {
        is_article_194_applied: new Validator("is_article_194_applied", async (value, column, {is_eu})=> {
            if(value &&  (!is_eu))
                return Promise.reject("Article 194 can be only applied to EU countries")
        }, ["is_eu"])
    },
    // enrichColumns: (columns)=>{
    //     return columns.map(x => {
    //         if (x.name === 'is_article_194_applied') {
    //             return {...x, editable: ({is_eu})=>is_eu === true}
    //         }
    //         return x;
    //     });
    // }
}
